var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitterLogoVX = function SvgTwitterLogoVX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#535768",
    d: "M14.23 10.892 21.878 2h-1.813l-6.642 7.72L8.119 2H2l8.022 11.675L2 23h1.813l7.014-8.153L16.43 23h6.118l-8.32-12.108zm-2.484 2.886-.813-1.162-6.467-9.251H7.25l5.22 7.465.813 1.163 6.784 9.704h-2.785z"
  })));
};
export default SvgTwitterLogoVX;